/*!
 * Copyright © 2021. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { VideoEventHttpService } from '../../../core/services';
import { getBalloon } from '../../../core/store/selectors';
import { IReplayBalloonVideoDetails } from '../../../replay/models';
import { IReplayBalloon } from '../../../replay/models/replay-balloon.interface';

@Component({
  selector: 'fm-video-event-details',
  templateUrl: './video-event-details.component.html',
  styleUrls: ['./video-event-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoEventDetailsComponent implements OnInit, OnDestroy {
  videoDetails$: Observable<IReplayBalloonVideoDetails>;

  private _videoDetails: IReplayBalloonVideoDetails;
  private _viewRecorded = false;
  private readonly _subscription = new Subscription();

  constructor(
    private readonly _store: Store,
    private readonly _dialogRef: MatLegacyDialogRef<VideoEventDetailsComponent>,
    private readonly _videoEventHttpService: VideoEventHttpService
  ) {}

  public ngOnInit(): void {
    this.videoDetails$ = this._store.pipe(
      select(getBalloon),
      map(balloon => (balloon as IReplayBalloon)?.videoDetails)
    );

    this._subscription.add(this.videoDetails$.subscribe(videoDetails => (this._videoDetails = videoDetails)));
  }

  public onVideoPlaying(): void {
    const eventKey = this._videoDetails?.eventKey;

    if (this._viewRecorded || !eventKey) {
      return;
    }

    this._viewRecorded = true;
    this._videoEventHttpService.recordEventView(eventKey).subscribe({
      error: () => (this._viewRecorded = false)
    });
  }

  public close(): void {
    this._dialogRef.close();
  }

  public ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
